import { createPortal } from "react-dom";
import { Box, Alert, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useTranslationApp } from "../../lib/i18next";
import {
  TRIAL_CONTENT_CTA_MESSAGE,
  TRIAL_CONTENT_CTA_BUTTON_SHARE_INSTAGRAM,
  TRIAL_CONTENT_CTA_BUTTON_SHARE_TIKTOK,
  TRIAL_CONTENT_CTA_BUTTON_MORE_OPTIONS,
} from "../../i18n/keysTranslations";
import Button from "../Buttons/Button";
import { logoPlatform } from "../../utils/string";
import { INSTAGRAM, TIKTOK } from "../../utils/constants";

const getItemForShareModal = (creatives) => {
  if (!creatives || creatives.length === 0) return null;
  const first = creatives[0] || {};
  const isCarousel = creatives.length > 1 || first?.isCarousel;
  if (isCarousel) {
    if (first?.carouselImages) {
      return {
        ...first,
        carouselImages: first.carouselImages,
        isCarousel: true,
      };
    }
    return { carouselImages: creatives, isCarousel: true };
  }

  if (first?.url) {
    return { url: first?.url };
  }

  if (typeof first === "string") {
    return { url: first };
  }
  return null;
};

const TrialContentCTAPopup = ({
  modalOpen,
  onCloseModal = () => {},
  creatives = [],
  onCreatePost = () => {},
}) => {
  const { t } = useTranslationApp();

  const itemForShare = getItemForShareModal(creatives);
  if (!modalOpen) return null;

  const popupContent = (
    <Box
      sx={{
        position: "fixed",
        bottom: 24,
        right: 16,
        zIndex: 1600,
      }}
    >
      <Alert
        severity="info"
        sx={{
          backgroundColor: "#fff",
          color: "text.primary",
          borderRadius: 2,
          boxShadow: "0 2px 16px rgba(0,0,0,0.15)",
          "& .MuiAlert-icon": { color: "info.main" },
        }}
        action={
          <IconButton
            size="small"
            aria-label="close"
            onClick={onCloseModal}
            sx={{ color: "text.secondary" }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
      >
        {t(TRIAL_CONTENT_CTA_MESSAGE)}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: "center",
            gap: 1,
            justifyContent: "flex-end",
            mt: 1,
          }}
        >
          <Button
            size="small"
            variant="contained"
            color="secondary"
            onClick={() => onCreatePost(itemForShare)}
            disabled={!itemForShare}
            startIcon={
              <Box
                component="img"
                src={logoPlatform(INSTAGRAM)}
                alt="Instagram"
                sx={{ width: 20, height: 20, objectFit: "contain" }}
              />
            }
            sx={{
              height: 38,
              width: { xs: "100%", sm: "auto" },
            }}
          >
            {t(TRIAL_CONTENT_CTA_BUTTON_SHARE_INSTAGRAM)}
          </Button>
          <Button
            size="small"
            variant="contained"
            color="secondary"
            onClick={() => onCreatePost(itemForShare)}
            disabled={!itemForShare}
            startIcon={
              <Box
                component="img"
                src={logoPlatform(TIKTOK)}
                alt="TikTok"
                sx={{ width: 20, height: 20, objectFit: "contain" }}
              />
            }
            sx={{
              height: 38,
              width: { xs: "100%", sm: "auto" },
            }}
          >
            {t(TRIAL_CONTENT_CTA_BUTTON_SHARE_TIKTOK)}
          </Button>
          <Button
            size="small"
            variant="contained"
            color="secondary"
            onClick={() => onCreatePost(itemForShare)}
            disabled={!itemForShare}
            sx={{
              height: 38,
              width: { xs: "100%", sm: "auto" },
            }}
          >
            {t(TRIAL_CONTENT_CTA_BUTTON_MORE_OPTIONS)}
          </Button>
        </Box>
      </Alert>
    </Box>
  );

  return createPortal(popupContent, document.body);
};

export default TrialContentCTAPopup;
